// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FLg8","fullView":"styles_fullView__1hu5q"};